import React from "react";

const WhyChooseUs = () => {
  return (
    <div className="why-choose-us">
      <div className="container">
        {/* Section Title */}
        <div className="row section-row">
          <div className="col-lg-12">
            <div className="section-title">
              <h3 className="wow fadeInUp">why choose us</h3>
              <h2 className="text-anime-style-3" data-cursor="-opaque">
                Experience comfort, trust, and excellence with Aaryan Travels
              </h2>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="row align-items-center">
          {/* Left Column */}
          <div className="col-lg-4 col-md-6 order-lg-1 order-md-1 order-1">
            <div className="why-choose-item wow fadeInUp">
              <div className="icon-box">
                <img src="images/icon-why-choose-1.svg" alt="" />
              </div>
              <div className="why-choose-content">
                <h3>extensive fleet options</h3>
                <p>
                  Choose from a wide range of well-maintained vehicles — from
                  budget-friendly cars to premium SUVs. Aaryan Travels ensures
                  the perfect ride for every occasion and need.
                </p>
              </div>
            </div>

            <div
              className="why-choose-item wow fadeInUp"
              data-wow-delay="0.25s"
            >
              <div className="icon-box">
                <img src="images/icon-why-choose-2.svg" alt="" />
              </div>
              <div className="why-choose-content">
                <h3>exceptional customer service</h3>
                <p>
                  Our dedicated support team is available 24/7 to assist you.
                  From booking to drop-off, we prioritize your comfort and make
                  sure every trip is smooth and stress-free.
                </p>
              </div>
            </div>
          </div>

          {/* Middle Image Column */}
          <div className="col-lg-4 col-md-12 order-lg-2 order-md-3 order-2">
            <div className="why-choose-image">
              <figure className="reveal">
                <img src="images/why-choose-img.jpeg" alt="" />
              </figure>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-4 col-md-6 order-lg-3 order-md-2 order-3">
            <div className="why-choose-item wow fadeInUp">
              <div className="icon-box">
                <img src="images/icon-why-choose-3.svg" alt="" />
              </div>
              <div className="why-choose-content">
                <h3>convenient locations</h3>
                <p>
                  With multiple pickup and drop-off points, Aaryan Travels makes
                  traveling across cities and states easy and accessible. We
                  bring the ride to you — wherever you are.
                </p>
              </div>
            </div>

            <div
              className="why-choose-item wow fadeInUp"
              data-wow-delay="0.25s"
            >
              <div className="icon-box">
                <img src="images/icon-why-choose-4.svg" alt="" />
              </div>
              <div className="why-choose-content">
                <h3>reliability and safety</h3>
                <p>
                  Your safety is our top priority. All Aaryan Travels vehicles
                  are regularly inspected, and our experienced drivers ensure
                  safe, punctual, and comfortable journeys every time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
